export default "__VITE_ASSET__CrZ9oLUD__"